export default __webpack_public_path__ + "static/butterfly-08063f4dd8c002acc57db79ebd17f24d.png";